export enum LogLevel {
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
    Verbose = "Verbose",
    Diagnostic = "Diagnostic"
}